import { render, staticRenderFns } from "./combineRecords.vue?vue&type=template&id=cda8a6d8&scoped=true&"
import script from "./combineRecords.vue?vue&type=script&lang=js&"
export * from "./combineRecords.vue?vue&type=script&lang=js&"
import style0 from "./combineRecords.vue?vue&type=style&index=0&id=cda8a6d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda8a6d8",
  null
  
)

component.options.__file = "combineRecords.vue"
export default component.exports